/**
 * Testing new copy and treatment for the signup modal cta
 */ export var BATCH_7_SIGNUP_MODAL_CTA_250212 = 'BATCH_7_SIGNUP_MODAL_CTA_250212';
